<template >
  <el-input
      size="medium"
      clearable
      @input="!content?$emit('input',null):null"
      v-on:keyup.native="monitor"
      placeholder="search by name or reference"
      v-model="content" ></el-input >
</template >
<script >
export default {
  name: 'ScInput',
  props: {
    value: {}
  },
  methods: {
    monitor: _.debounce(
        function (ev) {
          this.$emit('input', ev.target.value)
          _log_('up....', ev.target.value)
        },
        850,
        {maxWait: 1200}
    ),
    // monitor(ev) {
    //   this.$emit('input', ev.target.value)
    //   _log_('up....', ev.target.value)
    // }
  },
  data() {
    return {content: this.value}
  },
  watch: {
    value(v, vo) {
      if (v != vo && v != this.content) this.content = v
    }
  }
}
</script >
<style >

tr.el-table__row.drop-row td {
  border: 1px dotted;
}

</style >
